import {createSlice} from '@reduxjs/toolkit';
import News from '../../models/news.model';
import pageMeta from '../../models/pagemeta.model';

interface newsState{
  notices:Array<News> | undefined,
  loading:boolean,
  error:any,
  meta:pageMeta | undefined
}
const initialState:newsState = {
  notices:undefined,
  error:undefined,
  loading:false,
  meta:undefined,
}

const noticeSlice = createSlice({
  name:'notice',
  initialState:initialState,
  reducers:{
    
    fetchNoticesRequest(state){
      state.loading = true;
    },

    fetchNoticesSuccess(state,actions){
      state.loading = false;
      state.notices= actions.payload.notices;
      state.meta = actions.payload.meta;
    },


    fetchNoticesFail(state,actions){
      state.loading = false;
      state.error= actions.payload;
    },

  }
});

export const {
  fetchNoticesFail,
  fetchNoticesRequest,
  fetchNoticesSuccess
} = noticeSlice.actions;


export default noticeSlice.reducer;